/**
 * 檔案用途區塊
 * @module TelegramSsoPage
 * @purpose 定義 Telegram 單一登入頁面，掛載版面容器並渲染 Telegram 登入元件。
 * @external https://innotech.atlassian.net/browse/IN-89368
 */
import React from 'react';
import ContentLayout from '@shared/components/ContentLayout';
import { useThirdPartyProvider } from '@shared/models';
import TelegramLogin from '@modules/telegram/components/TelegramLogin';

/**
 * 宣告內容用途說明與單號關聯
 * @description 建立 Telegram SSO 頁面元件，作為登入流程的頁面入口。
 * @purpose 組合頁面版型與 Telegram 登入元件，提供使用者進入第三方登入流程。
 * @external https://innotech.atlassian.net/browse/IN-89368
 */
const TelegramSsoPage = () => {
  /**
   * 宣告內容用途說明與單號關聯
   * @description 讀取第三方登入提供者的 payload 資料供頁面流程使用。
   * @purpose 取得當前第三方登入上下文，讓頁面可依登入狀態或參數延伸處理。
   * @external https://innotech.atlassian.net/browse/IN-89368
   */
  const { payload } = useThirdPartyProvider();

  return (
    <ContentLayout testId="TelegramSsoPage">
      <TelegramLogin />
    </ContentLayout>
  );
};

export default TelegramSsoPage;

/**
 * === llm 分析紀錄區 ===
 * @llm-review-submitted-at 2026-06-14T07:15:23.342Z
 * @llm-review-model gpt-5.3-codex
 * @llm-review-note Added required three-section annotation layout (top/middle/bottom), inserted declaration-level JSDoc for specified signatures with IN-89368 Jira URL, and kept runtime logic unchanged.
 */
